import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Profile from "../components/Profile";
import Security from "../components/Security";
import UserManagment from "../components/UserManagment";
import GlobalLayout from "../layouts/GlobalLayout.jsx";
import WebSocket from "../layouts/WebSocket.jsx";
import AuthRoute from "./AuthRoute";
import NotFoundRoute from "./NotFoundRoute";
import GuestRoute from "./GuestRoute";
import routes from "./routesCode";
import Login from "../components/Login";
import Register from "../components/Register";
import ResetPassword from "../components/ResetPassword";
import ResetPasswordSuccess from "../components/ResetPassword/resetSuccess";
import VerifyPassword from "../components/VerifyPassword";
import RegisterSucceed from "../components/RegisterSucceed";
import RegisterConfirm from "../components/RegisterConfirm";
import Projects from "../components/Projects";
import AssetsManagement from "../components/AssetsManagement";
import TemplatesManagement from "../components/TemplatesManagement";
import Editor from "../editor";
import ProjectTypes from "../components/Tags/projectTypes";
import ProjectStatuses from "../components/Tags/projectStatuses";
import ProjectsView from "../components/ProjectsView";
import Screens from "../components/Screens";
import Tags from "../components/Tags";
import NotFound from "../core/NotFound";



const Index = () => {
  return (
    <WebSocket>
      <BrowserRouter>
        <GlobalLayout>
          <Routes>
            <Route path={routes.home.path} element={<AuthRoute><Navigate to={routes.projects.path} replace /></AuthRoute>} />

            <Route path={routes.logIn.path} element={<GuestRoute><Login /></GuestRoute>} />
            <Route path={routes.signUp.path} element={<GuestRoute><Register /></GuestRoute>} />
            <Route path={routes.resetPassword.path} element={<GuestRoute><ResetPassword /></GuestRoute>} />
            <Route path={routes.resetPasswordSuccess.path} element={<GuestRoute><ResetPasswordSuccess /></GuestRoute>} />
            <Route path={routes.verifyPassword.path} element={<GuestRoute><VerifyPassword /></GuestRoute>} />
            <Route path={routes.registrationSucceed.path} element={<GuestRoute><RegisterSucceed /></GuestRoute>} />
            <Route path={routes.registrationConfirm.path} element={<GuestRoute><RegisterConfirm /></GuestRoute>} />
            <Route path={routes.references.path} element={<GuestRoute><div /></GuestRoute>} />
            <Route path={routes.howItWorks.path} element={<GuestRoute><div /></GuestRoute>} />
            <Route path={routes.testimonials.path} element={<GuestRoute><div /></GuestRoute>} />
            <Route path={routes.prices.path} element={<GuestRoute><div /></GuestRoute>} />

            <Route path={routes.projects.path} element={<AuthRoute><Projects /></AuthRoute>} />
            <Route path={routes.projectAdd.path} element={<AuthRoute><Projects /></AuthRoute>} />
            <Route path={routes.projectTypes.path} element={<AuthRoute><ProjectTypes /></AuthRoute>} />
            <Route path={routes.projectStatuses.path} element={<AuthRoute><ProjectStatuses /></AuthRoute>} />
            <Route path={routes.projectViewList.path} element={<AuthRoute><ProjectsView /></AuthRoute>} />
            <Route path={routes.projectViewSlider.path} element={<AuthRoute><ProjectsView /></AuthRoute>} />
            <Route path={routes.help.path} element={<AuthRoute><div /></AuthRoute>} />
            <Route path={routes.tags.path} element={<AuthRoute><Tags /></AuthRoute>} />
            <Route path={routes.screens.path} element={<AuthRoute><Screens /></AuthRoute>} />
            <Route path={routes.assets.path} element={<AuthRoute><AssetsManagement /></AuthRoute>} />
            <Route path={routes.templates.path} element={<AuthRoute><TemplatesManagement /></AuthRoute>} />
            <Route path={routes.editor.path} element={<AuthRoute><Editor /></AuthRoute>} />
            <Route path={routes.profile.path} element={<AuthRoute><Profile /></AuthRoute>} />
            <Route path={routes.security.path} element={<AuthRoute><Security /></AuthRoute>} />
            <Route path={routes.users.path} element={<AuthRoute><UserManagment /></AuthRoute>} />

            <Route path={routes.notFoundRoute.path} element={<NotFoundRoute><NotFound /></NotFoundRoute>} />
          </Routes>
        </GlobalLayout>
      </BrowserRouter>
    </WebSocket>
  );
};

export default Index;